import { Input } from 'antd';
import type { HTMLInputTypeAttribute } from 'react';
import React from 'react';
import type { RegisterOptions } from 'react-hook-form';
import { Controller, useFormContext } from 'react-hook-form';

import type { InputNoteConfig } from '../_common';
import {
  getHookFieldClass,
  getHookGroupClass,
  renderErrorMessage,
  renderHookInputHeader
} from '../_common';

interface TextInputProps {
  name: string;
  type?: HTMLInputTypeAttribute;
  placeholder?: string;
  label?: string;
  required?: boolean;
  options?: RegisterOptions;
  disabled?: boolean;
  autoComplete?: string;
  inputNote?: InputNoteConfig;
  customOnBlur?: (e: React.FocusEvent<HTMLInputElement, Element>) => void;
  maxLength?: number;
  hideLabel?: boolean;
}

const TextInput = ({
  name,
  label,
  options,
  disabled,
  placeholder,
  required,
  type,
  autoComplete,
  inputNote,
  customOnBlur,
  maxLength,
  hideLabel
}: TextInputProps) => {
  const { control, getFieldState, formState } = useFormContext();

  const { invalid, isDirty, error, isTouched } = getFieldState(name, formState);

  const showError = !!error && isDirty;

  return (
    <div className={getHookGroupClass(label, 'TextInput')}>
      {!hideLabel && renderHookInputHeader(name, label, required, inputNote)}
      <Controller
        name={name}
        control={control}
        rules={options}
        render={({ field }) => (
          <Input
            {...field}
            id={name}
            placeholder={placeholder}
            type={type}
            className={getHookFieldClass(isTouched, invalid)}
            disabled={disabled}
            autoComplete={autoComplete}
            maxLength={maxLength}
            onBlur={(e) => {
              if (customOnBlur) customOnBlur(e);
              field.onBlur();
            }}
          />
        )}
      />
      {renderErrorMessage(showError, error?.message)}
    </div>
  );
};

export default TextInput;
